
import  RouteConstants  from "@/app/core/RouteConstants";

export default {
  path: RouteConstants.DOWNLOAD_STUDIES.path,
  name: RouteConstants.DOWNLOAD_STUDIES.name,
  component: () => import("@/app/views/downloadStudy/DownloadStudyView.vue"),
  meta: {
    requireAuth: false
  },
};
